export default __webpack_public_path__ + "media/images/main/r-input-ef82d6218ba4853470430ca410fa2d13.png";